import { Alert, Box, Button, Input, Option, Select, Stack, Typography } from "@mui/joy"
import { useDispatch, useSelector } from "react-redux"
import { novoLivro, salvarLivro } from "./LivrudoSlice"
import { useState } from "react";
import { Navigate } from "react-router-dom";


function generateId() {
    const prefix = "ID-";
    const randomNumbers = Array.from({ length: 8 }, () =>
        Math.floor(Math.random() * 10)
    ).join("");
    return `${prefix}${randomNumbers}`;
}

function AddLivroPage() {

    var dispatch = useDispatch()
    var livros = useSelector((state) => state.livrudo.db.livros)

    const [form, setForm] = useState({
        id : null,
        nome : "",
        isbn : "",
        editora : "",
        tipo : "",
        categoria : "",
        data : "",
        erro: "",
        ultimoEstado : "COMPRADO_AGUARDANDO_RECEBIMENTO",
        redirectAfter: false,
    });


    if (form.id == null) {
        var idValido = false
        var novoId = "";
        while (!idValido) {
            novoId = generateId()
            idValido = livros.filter(livro => livro.id === novoId).length == 0;
        }
        setForm((prev) => ({ ...prev, id: novoId }))
    }


    const handleChange = (field, value) => {
        if (value != null) {
            setForm((prev) => ({ ...prev, [field]: value }))
        }
    }
    const handleSubmit = () => {
        var erro = null;
        setForm((prev) => ({ ...prev, erro: erro}))

        // Validação do nome
        if (!form.nome || form.nome.trim().length < 3) {
            erro = "O nome não pode ser vazio e deve ter pelo menos 3 caracteres.";
        } else if (form.isbn.trim().length > 0 && !/^\d+$/.test(form.isbn)) {
            erro = "O ISBN deve conter apenas números.";
        } else if (!form.tipo || form.tipo.trim() === "") {
            erro = "O tipo não pode ser vazio ou nulo.";
        } else if (!form.editora || form.editora.trim().length < 3) {
            erro = "O editora não pode ser vazio ou nulo.";
        } else if (!form.categoria || form.categoria.trim() === "") {
            erro = "A categoria não pode ser vazia ou nula.";
        }
        
        if (erro != null) {
            setForm((prev) => ({ ...prev, erro: erro }))
        } else {
            dispatch(salvarLivro(novoLivro(
                form.id,
                form.nome,
                form.isbn,
                form.editora,
                form.tipo,
                form.categoria,
                form.data
            )))
            setForm((prev) => ({ ...prev, redirectAfter: true }))
        }
    }
    const selectCategoria = (e, value) => {
        setForm((prev) => ({ ...prev, categoria: value }))
    }
    const selectTipo = (e, value) => {
        setForm((prev) => ({ ...prev, tipo: value }))
    }

    if (form.redirectAfter) {
        return <Navigate to={"/livrudo/livros/" + form.id} />
    }

    return <Stack>
        <Box sx={{ p: 3, maxWidth: 500, mx: "auto" }}>
            <Typography level="h4" sx={{ mb: 2 }}>
                Formulário de Livro
            </Typography>
            <Alert color="danger" sx={{ mb: 2 }}>
                {form.erro}
            </Alert>
            <Input
                placeholder="Nome"
                value={form.nome}
                onChange={(e) => handleChange("nome", e.target.value)}
                required
                sx={{ mb: 2 }}
            />
            <Input
                placeholder="ISBN"
                value={form.isbn}
                onChange={(e) => handleChange("isbn", e.target.value.replace(/\D/g, ''))}
                sx={{ mb: 2 }}
            />
            <Input
                placeholder="Editora"
                value={form.editora}
                onChange={(e) => handleChange("editora", e.target.value)}
                sx={{ mb: 2 }}
            />
            <Input
                placeholder="Data"
                value={form.data}
                onChange={(e) => handleChange("data", e.target.value)}
                sx={{ mb: 2 }}
            />
            <Select
                placeholder="Tipo"
                value={form.tipo}
                onChange={selectTipo}
                required
                sx={{ mb: 2 }}
            >
                <Option value="BOLSO_ECONOMICO">Bolso - Econômico</Option>
                <Option value="CAPA_COMUM">Capa Comum</Option>
                <Option value="CAPA_DURA">Capa Dura</Option>
                <Option value="BOX">Box</Option>
            </Select>
            <Select
                placeholder="Categoria"
                value={form.categoria}
                onChange={selectCategoria}
                required
                sx={{ mb: 2 }}
            >
                <Option value="LITERATURA">Literatura</Option>
                <Option value="LITERATURA_LINGUAS">Literatura - Línguas</Option>
                <Option value="RPG">RPG</Option>
            </Select>
            <Button type="submit" onClick={handleSubmit} variant="solid" sx={{ width: "100%" }}>
                Enviar
            </Button>
        </Box>
    </Stack>

}

export default AddLivroPage